import React, { useState, useEffect } from 'react';
import config from '../../Common/Configurations/APIConfig';
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from '../../Common/Configurations/AuthContext';
import Modal from 'react-bootstrap/Modal';
import { Link, useNavigate } from 'react-router-dom';
import DeleteAlert from '../../Common/Layout/DeleteAlert';
const initialFieldValues = {
    companyMenuId: "00000000-0000-0000-0000-000000000000",
    companyId: "00000000-0000-0000-0000-000000000000",
    menuName: "",
    menuType: "",
    menuPath: ""
};
const CompanyMenu = ({ show, handleClose, companyId }) => {
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    const [btnLoading, setBtnLoading] = useState(false);
    const [lists, setLists] = useState([]);
    const [values, setValues] = useState(initialFieldValues);
    const [errors, setErrors] = useState({});
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const handleOpenDeleteModal = (id) => {
        setItemToDelete(id);
        setShowDeleteModal(true);
    };
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setItemToDelete(null);
    };
    useEffect(() => {
        if (recordForEdit !== null) {
            setValues(recordForEdit);
        }
    }, [recordForEdit]);
    const GetData = async () => {
        const res = await apiService.get(`${config.GETCOMPANYMENUBYCOMPANY}/${companyId}`, "100", '1');
        console.log(res);
        if (res.length > 0) {
            setLists(res.data);
        }
    };
    const showEditDetails = (data) => {
        setRecordForEdit(data);
        setValues(data);
    };
    const handleDelete = async () => {
        if (itemToDelete !== null) {
            try {
                await apiService.remove(config.DELETECOMPANYMENU, itemToDelete)
                await GetData();
            } catch (error) {
                // Error toast already handled by apiService
                // Optionally log or track error here
            }
            handleCloseDeleteModal();
        }
    }
    const validate = () => {
        let temp = {};
        temp.menuName = values.menuName === "" ? false : true;
        temp.menuPath = values.menuPath === "" ? false : true;
        temp.menuIcon = values.menuIcon === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnLoading(true);
            var formData = {
                "companyMenuId": values.companyMenuId,
                "menuName": values.menuName,
                "menuPath": values.menuPath,
                "menuIcon": values.menuIcon,
                "companyId": companyId,
            }
            try {
                const isNew = formData.companyMenuId === "00000000-0000-0000-0000-000000000000";

                if (isNew) {
                    await apiService.create(config.CREATECOMPANYMENU, formData);
                } else {
                    await apiService.update(config.UPDATECOMPANYMENU, formData);
                }
                await GetData();
                resetForm();

            } finally {
                setBtnLoading(false); // ensure loading button resets even on error
            }
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const fieldsToUppercase = ["branchName"];
        setValues({
            ...values,
            [name]: fieldsToUppercase.includes(name) ? value.toUpperCase() : value
        });
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setBtnLoading(false);
    };
    const applyErrorClass = (field) => field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        if (user && !loading) {
            if (companyId !== null) {
                GetData();
            }
        }
    }, [user, loading]);
    if (loading) return <p>Loading...</p>;
    if (!user) { navigate("/") };
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title>{values.companyMenuId === "00000000-0000-0000-0000-000000000000" ? "Add" : "Edit"} Company Menu</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive table-card p-2">
                            <table className="table align-middle" id="customerTable">
                                <thead className="bg-soft-success bg-gradient">
                                    <tr>
                                        <th>Id</th>
                                        <th>Menu Name</th>
                                        <th>Menu Icon</th>
                                        <th>Menu Path</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody className="list form-check-all">
                                    {lists.length > 0 && lists.map((v, index) =>
                                        <tr key={v.branchId}>
                                            <td>{index + 1}</td>
                                            <td>{v.branchName}</td>
                                            <td>{v.branchType}</td>
                                            <td>{v.companyName}</td>
                                            <td>
                                                <ul className="list-inline hstack gap-2 mb-0">
                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                        <Link className="edit-item-btn" onClick={e => showEditDetails(v)}><i className="ri-pencil-fill align-bottom text-muted" /></Link>
                                                    </li>
                                                    <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                        <Link className="remove-item-btn" onClick={e => handleOpenDeleteModal(v.branchId)}>
                                                            <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        <div className="row">
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="menuName" className="form-label">Menu Name</label>
                                <input type="text" max={45} value={values.menuName} name="menuName" onChange={handleInputChange} className={"form-control" + applyErrorClass('menuName')} placeholder="Please Enter Menu Name" />
                                {errors.menuName === false ? (<div className="validationerror">Please enter name </div>) : ('')}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="menuIcon" className="form-label">Menu Icon</label>
                                <input type="text" max={45} value={values.menuIcon} name="menuIcon" onChange={handleInputChange} className={"form-control" + applyErrorClass('menuIcon')} placeholder="Please Enter Menu Icon" />
                                {errors.menuIcon === false ? (<div className="validationerror">Please enter icon </div>) : ('')}
                            </div>
                            <div className="col-lg-12 mb-3">
                                <label htmlFor="menuPath" className="form-label">Menu Path</label>
                                <input type="text" max={100} value={values.menuPath} name="menuPath" onChange={handleInputChange} className={"form-control" + applyErrorClass('menuPath')} placeholder="/flights/search" />
                                {errors.menuPath === false ? (<div className="validationerror">Please enter path </div>) : ('')}
                            </div>
                            <Modal.Footer>
                                <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                    {
                                        btnLoading === false ?
                                            <button type="submit" className="btn btn-primary">{values.branchId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update"}</button>
                                            :
                                            <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                    }
                                    <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                                </div>
                            </Modal.Footer>
                        </div>
                    </form>
                    <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete} />
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default CompanyMenu;
